import { render, staticRenderFns } from "./MaterialProjectDetail.vue?vue&type=template&id=390c450e&scoped=true"
import script from "./MaterialProjectDetail.vue?vue&type=script&lang=js"
export * from "./MaterialProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./MaterialProjectDetail.vue?vue&type=style&index=0&id=390c450e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c450e",
  null
  
)

export default component.exports